import React from 'react';
import { Outlet } from 'react-router-dom';
import { TopNav } from '../components/layout/TopNav';

export default function ClientPortalLayout() {
  return (
    <div className="min-h-screen bg-slate-50 dark:bg-zinc-950">
      <TopNav />
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <Outlet />
      </main>
    </div>
  );
}
